import { render, staticRenderFns } from "./inskin.vue?vue&type=template&id=7dbded0a&scoped=true&"
import script from "./inskin.vue?vue&type=script&lang=js&"
export * from "./inskin.vue?vue&type=script&lang=js&"
import style0 from "./inskin.vue?vue&type=style&index=0&id=7dbded0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbded0a",
  null
  
)

export default component.exports